import availabilityBadgeColorService from 'src/services/inventory/sales-restrictions/AvailabilityBadgeColorService'
import availableStockService from 'src/services/inventory/sales-restrictions/AvailableStockService'
import hasReducedOpacityService from 'src/services/inventory/sales-restrictions/HasReducedOpacityService'
import isAvailabilityBadgeVisibleService from 'src/services/inventory/sales-restrictions/isAvailabilityBadgeVisibleService'
import isOutOfStockService from 'src/services/inventory/sales-restrictions/IsOutOfStockService'

export const availabilityBadgeColor = availabilityBadgeColorService.availabilityBadgeColor
export const availableStock = availableStockService.availableStock
export const hasReducedOpacity = hasReducedOpacityService.hasReducedOpacity
export const isAvailabilityBadgeVisible = isAvailabilityBadgeVisibleService.isAvailabilityBadgeVisible
export const isOutOfStock = isOutOfStockService.isOutOfStock
